export const ComissionListColums = [
  {
    name: "Nombre",
    selector: (row) => row["name"],
    sortable: true,
    center: false,
  },
  {
    name: "Jurisdiccion",
    selector: (row) => row["jurisdiction"]?.name,
    sortable: true,
    center: false,
  },
];
